import React, { Component } from 'react';
import 'lazysizes/lazysizes.min';
import logo from './logo.svg';
import './App.css';
import SectionCarousel from './gallery';

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <h1 className="App-title">Welcome to React</h1>
        </header>
        <p className="App-intro">
          To get started, edit <code>src/App.js</code> and save to reload.
        </p>
          <div className="carousel-container">
              <SectionCarousel/>
          </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js